import { inject } from "aurelia-framework";
import { Redirect } from "aurelia-router";
import { I18N } from "aurelia-i18n";

import { default as apiHelper } from "helpers/apiHelper";
import { default as dateHelper } from "helpers/dateHelper";
import { default as settingHelper } from "helpers/settingHelper";
import { default as queryStringHelper } from "helpers/queryStringHelper";

import { default as templateService } from "services/templateService";
import { default as purchaseOrderService } from "services/purchaseOrderService";
import { NotificationHelper } from "helpers/notification-helper";
import { Router } from "aurelia-router";
import { FormBase } from "pages/form-base";

@inject(I18N, NotificationHelper, Router)
export default class MaterialOrderItem extends FormBase {

    workOrderId;
    lineNo = '';
    orderDate = null;
    orderId = '';
    extension = '';
    showNotInCatalog = false;
    readonly = false;
    isDirty = false;

    constructor(i18n, notificationHelper, router) {
        super(notificationHelper, i18n, router);
        this.i18n = i18n;
    }

    checkDirty() {
        return this.isDirty;
    }

    setSpecificFields(item) {
        item.DispatchId = 0;
        return item;
    }

    bindComponentActions() {
        this.actions = {
            setSpecificFields: item => this.setSpecificFields(item),
            savePurchaseOrderItem: (orderId, lineNo, item) => purchaseOrderService.setPurchaseOrderItemForWorkOrder(this.workOrderId, orderId, lineNo, item)
        };
    }

    canActivate() {
        if (!settingHelper.hasDispatchModel()) {
            this.notificationHelper.showWarning(this.i18n.tr("DispatchModelRequired"),"");
            return new Redirect("Settings");
        }
        return true;
    }

    activate(params) {
        this.workOrderId = decodeURIComponent(params.workOrderId);
        this.requisitionDate = dateHelper.dateFromNavigationParameter(params.orderDate);
        this.orderId = params.orderId;
        this.catalogBaseUrl = apiHelper.getBaseUrl() +
            "/catalog/fieldservices/materialrequisitions?dispatchTemplateId=" +
            settingHelper.getSelectedDispatchModel();
        this.lineNo = params.lineNo;

        if (params.q) {
            this.readonly = queryStringHelper.parseReadonly(params.q);

            const extension = queryStringHelper.parse(params.q, "extension");
            this.projectId =  queryStringHelper.parse(params.q, "projectCode") !== "null" ? queryStringHelper.parse(params.q, "projectCode") : undefined;

            this.extension = extension ? extension : "";
        }
        this.bindComponentActions();

        return templateService.getUserTemplateConfigs().done((configs) => {
            this.showNotInCatalog = configs.ShowNotInCatalogMaterialFieldService;
        });
    }
}